// client/src/components/NFTList.js
import React, { useState, useEffect } from 'react';
import { getNFTList, getImageUrl } from './api';
import './NFTList.css';

const NFTList = ({ collectionName, onSelectNFT, onBack, onRegisterClick }) => {
  const [nfts, setNfts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 페이지 로드 시 스크롤을 맨 위로 이동
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    loadNFTs();
  }, [collectionName]);

  const loadNFTs = async () => {
    try {
      setLoading(true);
      setError('');
      const result = await getNFTList(collectionName);
      const sortedNfts = (result.nfts || []).sort((a, b) => a.id - b.id);
      setNfts(sortedNfts);
    } catch (err) {
      setError(err.error || 'NFT 목록을 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="nft-list-container">
        <button onClick={onBack} className="back-btn">← 뒤로가기</button>
        <div className="loading">NFT 목록을 불러오는 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="nft-list-container">
        <button onClick={onBack} className="back-btn">← 뒤로가기</button>
        <div className="error-message">{error}</div>
        <button onClick={loadNFTs} className="retry-btn">다시 시도</button>
      </div>
    );
  }

  return (
    <div className="nft-list-container">
      <div className="nft-list-header">
        <button onClick={onBack} className="back-btn">← 뒤로가기</button>
        <div className="header-title">
          <h2>{collectionName}</h2>
          <p className="nft-count">총 {nfts.length}개의 NFT</p>
        </div>
        <button onClick={onRegisterClick} className="register-btn">
          ➕ NFT 등록
        </button>
      </div>

      {nfts.length === 0 ? (
        <div className="empty-message">
          <p>이 컬렉션에는 NFT가 없습니다.</p>
        </div>
      ) : (
        <div className="nft-grid">
          {nfts.map((nft) => (
            <div 
              key={nft.id}
              className="nft-card"
              onClick={() => onSelectNFT(nft.id)}
            >
              <div className="nft-image">
                <img 
                  src={getImageUrl(nft.nftImageUri)} 
                  alt={`Token #${nft.tokenId}`}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/300?text=Image+Not+Found';
                  }}
                />
              </div>
              <div className="nft-info">
                <h3>Token #{nft.tokenId}</h3>
                {nft.description && (
                  <p className="nft-description">{nft.description}</p>
                )}
                <p className="nft-date">
                  {new Date(nft.createdAt).toLocaleDateString('ko-KR')}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NFTList;